import React from "react";

const FoyerDelete = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
      <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-lg">
        <h1 className="text-2xl font-bold mb-4">Foyer — Account Deletion Request</h1>
        <p className="mb-4 text-gray-700">
          To request deletion of your Foyer account and all associated household
          data, please send an email to the address below. We will process your
          request within 30 days.
        </p>

        <h2 className="text-xl font-semibold mb-2">How to Request Deletion</h2>
        <ol className="list-decimal list-inside mb-6 text-gray-700 space-y-1">
          <li>Email <strong>tom@atticuslabs.net</strong> from the address associated with your Foyer account.</li>
          <li>Use the subject line: <strong>Foyer Account Deletion Request</strong></li>
          <li>We will confirm receipt and complete the deletion within 30 days.</li>
        </ol>

        <h2 className="text-xl font-semibold mb-2">What Gets Deleted</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700 space-y-1">
          <li>Your Foyer account and login credentials</li>
          <li>All household data including members, chores, lists, meals, and calendar sources</li>
          <li>Calendar events synced to your household</li>
          <li>Push notification tokens associated with your devices</li>
        </ul>

        <a
          href="mailto:tom@atticuslabs.net?subject=Foyer%20Account%20Deletion%20Request"
          className="inline-block bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition"
        >
          Email Deletion Request
        </a>
      </div>
    </div>
  );
};

export default FoyerDelete;
